module.exports = __webpack_public_path__ + "cc2c414873637ac69edeece663cb0b54.png";